import { useSessionStore } from "@features/session";
import useMixedItemDist from "@hooks/useMixedItemDist";
import { router } from "expo-router";
import { useCallback, useMemo } from "react";
import {
	getProethicaEntryShortLabel,
	getProethicaOrderedEntries,
} from "../helpers/proethica-module-list";
import { useProethicaModuleList } from "./useProethicaModuleList";

// Drives the "Continue to next module" CTA on the session report: resolve the
// next entry in the dashboard learning path (next module, or an injected
// pre/post test) and start it via the same once-only start flow the dashboards
// use. With no next entry (end of path), fall back to home.
export const useProethicaNextModule = (currentModuleId?: string) => {
	const { data: mixedItemDist } = useMixedItemDist();
	const { startModule, startingModuleId } = useProethicaModuleList();
	const resetSessionStore = useSessionStore((state) => state.resetSessionStore);

	const nextEntry = useMemo(() => {
		if (!currentModuleId) {
			return undefined;
		}
		const entries = getProethicaOrderedEntries(mixedItemDist?.tags);
		const index = entries.findIndex(
			(entry) => String(entry.id) === currentModuleId,
		);
		return index >= 0 ? entries[index + 1] : undefined;
	}, [mixedItemDist, currentModuleId]);

	const handleContinueToNextModule = useCallback(() => {
		if (!nextEntry) {
			resetSessionStore();
			router.replace("/(protected)/(tabs)/home");
			return;
		}
		return startModule(String(nextEntry.id));
	}, [nextEntry, resetSessionStore, startModule]);

	return {
		nextEntry,
		nextModuleLabel: nextEntry
			? getProethicaEntryShortLabel(nextEntry)
			: undefined,
		handleContinueToNextModule,
		isStartingNextModule: startingModuleId != null,
	};
};
